import { Fetch } from 'lib';

export type ImportResult = {
  errors: ImportError[];
  totalProductChanged: number;
  totalSubProductChanged: number;
  totalRow: number;
};

type ImportError = {
  message: string;
  row: number;
};

type RequestResponses = ImportResult;

type RequestParameters = {
  fileId: string;
};

const importProducts = async ({ fileId }: RequestParameters) => {
  const params: Record<string, unknown> = {
    fileId: fileId,
  };

  return await Fetch<RequestResponses, typeof params>({
    url: 'adminProduct/importProducts',
    params,
    method: 'POST',
  });
};

export { importProducts };
